module.exports = __webpack_public_path__ + "img/film-4.6ad0abda.png";